<div *ngIf="displayDropzone" class="mb-3">
    <mat-form-field appearance="fill">
        <mat-label>Drop files here or click to upload</mat-label>
        <ngx-mat-dropzone>
            <input #filesCtrl type="file" fileInput multiple (selectionChange)="uploadFiles($event || [])" />

            @for (file of files; track file.name) {
            <mat-chip-row>
                {{ file.name }}
            </mat-chip-row>
            }
        </ngx-mat-dropzone>
    </mat-form-field>
</div>

<div *ngIf="isUploading()" class="upload-progress">
    <mat-progress-bar mode="determinate" [value]="uploadProgress$ | async"></mat-progress-bar>
    <div class="progress-text">{{ uploadProgress$ | async }}%</div>
</div>

<div *ngFor="let download of downloadsInProgress">
    <div class="download-progress">
        {{ download.attachment.FileName }} - {{ download.status | async }}
        <mat-progress-bar mode="determinate" [value]="download.progress| async"></mat-progress-bar>
        <div class="progress-text">{{ download.progress | async }}%</div>
    </div>
</div>

@if (nameOfFactory(attachmentData); as nameOf) {
<kendo-grid [kendoGridBinding]="attachmentData" [height]="gridHeight" [pageSize]="100" [pageable]="true" [sortable]="true"
    [resizable]="true" [reorderable]="true" [filterable]="true" [loading]="loading()">

    <kendo-grid-column *ngIf="displayDownloadButton" title=" " [width]="40">
        <ng-template kendoGridCellTemplate let-dataItem>
            <button type="button" class="btn btn-ticomix" (click)="downloadAttachment(dataItem)"><span
                    class="fa fa-download"></span></button>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column *ngIf="displayEditButton" title=" " [width]="40">
        <ng-template kendoGridCellTemplate let-dataItem>
            <button type="button" class="btn btn-ticomix" (click)="editAttachment(dataItem)"><span
                    class="fa fa-pencil"></span></button>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [field]="nameOf('FileName')" title="File Name" [width]="120"></kendo-grid-column>
    <kendo-grid-column [field]="nameOf('Description')" title="File Description" [width]="200"></kendo-grid-column>
    <kendo-grid-column [field]="nameOf('FileType')" title="File Type" [width]="90"></kendo-grid-column>
    <kendo-grid-column [field]="nameOf('AttachmentTypeCode')" title="Attachment Type" [width]="100"></kendo-grid-column>
    <kendo-grid-column [field]="nameOf('AddUser')" title="Add User" [width]="90"></kendo-grid-column>
    <kendo-grid-column [field]="nameOf('AddDate')" title="Add Date" [width]="90">
        <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem[nameOf('AddDate')] | date:'short' }}
        </ng-template>
    </kendo-grid-column>
</kendo-grid>
}